export enum DialerQueueGroup {
  DUE_NOW = "DUE_NOW",
  RETRY_LATER = "RETRY_LATER",
  OUTSIDE_CALLING_HOURS = "OUTSIDE_CALLING_HOURS",
  DAILY_CAP = "DAILY_CAP",
  SKIPPED = "SKIPPED",
  DONE = "DONE",
}
